import * as React from 'react';
import {Autocomplete, CircularProgress, Divider, TextField} from "@mui/material";
import {ReactComponent as Plus} from "../../assets/img/icons/plus.svg";
import SimpleMap from "../../components/SimpleMap";
import {useTranslation} from "react-i18next";
import {
    setAddressReceiver,
    setCompanyReceiver,
    setEmailReceiver,
    setFirstNameReceiver,
    setLastNameReceiver,
    setLatReceiver,
    setLngReceiver,
    setMobileNumberReceiver,
    setPhoneNumberReceiver,
    setPostalCodeReceiver
} from "../../redux/singleOrder/receiver/actions";
import {useDispatch, useSelector} from "react-redux";
import {Cancel, Remove} from "@mui/icons-material";
import {
    handleBorderColor,
    handleCheckAddressWithState,
    removeNonNumeric,
    useShowMessageComponent,
    useOnlyEnglish
} from "../../assets/js/main";
import {useSnackbar} from "notistack";
import HandleFetchData from "../../plugin/HandleFetchData";
import {setAddressSender} from "../../redux/singleOrder/sender/actions";
import Compressor from "compressorjs";
import {setShipmentImages} from "../../redux/singleOrder/infoBox/actions";


export default function Receiver(props) {
    const {t} = useTranslation()
    const {enqueueSnackbar} = useSnackbar();
    const {fetchData} = HandleFetchData()
    const {showMessageComponent} = useShowMessageComponent()
    const {handleOnlyEnglish} = useOnlyEnglish()

    const dispatch = useDispatch();
    const selector = useSelector((st) => st)
    const serviceItem = selector?.single_services?.selectedService

    const [_loading, set_Loading] = React.useState(false);
    const [otherInput, setOtherInput] = React.useState(false);
    const [listAddress, setListAddress] = React.useState([])
    const [showMap, setShowMap] = React.useState(serviceItem?.CourierCode === "PEYKHUB" || serviceItem?.CourierCode === "LINK" || serviceItem?.CourierCode === "PUDO")


    // متد دریافت لیست آدرس های قبلی
    const handleGetPreviousAddress = async (e) => {
        set_Loading(true)
        let fetch = await fetchData('', 'GET', `/FetchAddresses?toSearch=${e}`, '', 'application/json', '', '', '')
        set_Loading(false)
        setListAddress(fetch?.Data || [])
    }


    const handleSetInfoReceiver = (value) => {
        dispatch(setFirstNameReceiver(value?.FirstName || ''))
        dispatch(setLastNameReceiver(value?.LastName || ''))
        dispatch(setPostalCodeReceiver(value?.ZipPostalCode || ''))
        dispatch(setEmailReceiver(value?.email || ''))
        dispatch(setCompanyReceiver(value?.Company || ''))
        dispatch(setMobileNumberReceiver(value?.PhoneNumber || ''))
        dispatch(setAddressReceiver(value?.Address1 || ''))
    }

    const onImageChange = (event) => {
        const shipment_images = selector?.single_info_box?.shipment_images || [];
        const files = Array.from(event.target.files);

        const newImages = [];
        let processedCount = 0;

        if (files.length > 3) {
            showMessageComponent(t("sendTicket.t32"), 'error');
        } else if ((files.length + shipment_images.length) > 3) {
            showMessageComponent(t("sendTicket.t32"), 'error');
        } else {
            files.forEach((file) => {
                if (file.size < 5000000) {
                    new Compressor(file, {
                        quality: 0.8, // 0.6 can also be used, but it's not recommended to go below.
                        success: (compressedResult) => {
                            const reader = new FileReader();
                            reader.readAsDataURL(compressedResult);
                            reader.onload = () => {
                                newImages.push(reader.result);
                                processedCount++;

                                if (processedCount === files.length) {
                                    dispatch(setShipmentImages([...shipment_images, ...newImages]));
                                }
                            };
                        },
                    });
                } else {
                    showMessageComponent(t("error.t49"), 'error');
                }
            });
        }
    };
    const removeIMG = (i) => {
        const item = [...selector?.single_info_box?.shipment_images]; // make a separate copy of the array
        item.splice(i, 1);
        dispatch(setShipmentImages(item))
    }

    return (
        <>
            <div className="receiverSingleOrderPage">

                <div className="row">

                    <div className="col-12">
                        <div className="info">
                            <div className="show-map">
                                <h4 className="titleSection">{t("singleOrder.receiver.t5")}</h4>

                                {selector?.single_info_box?.post_type === '0' &&
                                    <div className="btnGroup_light">
                                        <button type="button" className="btnEmpty" onClick={() => setShowMap(!showMap)}>
                                            <span>{showMap ? t("singleOrder.sender.t31") : t("singleOrder.sender.t32")}</span>
                                        </button>
                                    </div>
                                }

                            </div>
                            {/*<div className="container">*/}
                            <div className="inputGroup">
                                <div className="row">

                                    <div className="col-12">
                                        {selector?.single_info_box?.post_type === '0' && showMap &&
                                            <div className="maps">
                                                <label className="">{t("singleOrder.receiver.t29")}</label>

                                                <SimpleMap
                                                    handlerLngFromMap={(event) => dispatch(setLngReceiver(event))}
                                                    handlerLatFromMap={(event) => dispatch(setLatReceiver(event))}
                                                    handlerAddressFromMap={(event, i) => {
                                                        if (
                                                            handleCheckAddressWithState(event, selector?.single_receiver?.city_name, selector?.single_receiver?.state_name)) {
                                                            showMessageComponent('آدرس شما با شهر مقصد همخانی ندارد', 'error')
                                                        } else {
                                                            dispatch(setAddressReceiver(event))
                                                        }
                                                    }}
                                                    lngToMap={selector?.single_receiver?.lng}
                                                    latToMap={selector?.single_receiver?.lat}
                                                    coordinates={[
                                                        {
                                                            "pointX": selector?.single_receiver?.lat,
                                                            "pointY": selector?.single_receiver?.lng
                                                        }
                                                    ]}
                                                    searchInMap={selector?.single_receiver?.address}
                                                    cityToMap={selector?.single_receiver?.city_name}
                                                    stateToMap={selector?.single_receiver?.state_name}
                                                />
                                            </div>
                                        }

                                        <label className="required">{t("singleOrder.receiver.t20")}</label>
                                        <Autocomplete
                                            className={['w-100 mb-2', selector?.single_info_box?.post_type === '1' ? 'englishFont' : '']}
                                            inputValue={selector?.single_receiver?.address}
                                            noOptionsText={t("autoComplete.t1")}
                                            value={selector?.single_receiver?.address}
                                            id="previous-address-receiver-1"
                                            ref={props.addressRefReceiver}
                                            disablePortal
                                            onChange={(e, value, reason) => {
                                                if (reason === 'clear') {
                                                    handleSetInfoReceiver(null)
                                                } else {
                                                    selector?.single_info_box?.post_type === '1' ?
                                                        handleSetInfoReceiver(handleOnlyEnglish(value))
                                                        :
                                                        handleSetInfoReceiver(value)
                                                }
                                            }}
                                            options={listAddress || []}
                                            getOptionLabel={(option) => option?.Address1 || ''}
                                            renderOption={(props, option) => <li {...props}
                                                                                 key={option?.Id}>{option?.Address1}</li>}
                                            renderInput={(params) =>
                                                <TextField {...params}
                                                           hiddenLabel
                                                           size="small"
                                                           placeholder={t("singleOrder.sender.t16")}
                                                           style={handleBorderColor(selector?.public?.validations?.address_validation_Receiver)}
                                                           onChange={event => {
                                                               selector?.single_info_box?.post_type === '1' ?
                                                                   dispatch(setAddressReceiver(handleOnlyEnglish(event.target.value)))
                                                                   :
                                                                   dispatch(setAddressReceiver(event.target.value))
                                                               event.target.value?.length >= 3 && handleGetPreviousAddress(event.target.value)
                                                           }}
                                                           InputProps={{
                                                               ...params.InputProps,
                                                               endAdornment: (
                                                                   <React.Fragment>
                                                                       {_loading ?
                                                                           <CircularProgress style={{margin: '0 5px'}}
                                                                                             size={20}/> : null}
                                                                       {params.InputProps.endAdornment}
                                                                   </React.Fragment>
                                                               ),
                                                           }}
                                                />}
                                        />
                                        {/*<input type="text" autoComplete="on" name="address" ref={props.addressRefReceiver}*/}
                                        {/*       placeholder={t("singleOrder.receiver.t30")}*/}
                                        {/*       style={handleBorderColor(selector?.public?.validations?.address_validation_Receiver)}*/}
                                        {/*       value={selector?.single_receiver?.address} id="address"*/}
                                        {/*       onChange={e => dispatch(setAddressReceiver(e.target.value))}/>*/}

                                        {
                                            selector?.public?.validations?.address_validation_Receiver &&
                                            <p className="error">{selector?.public?.validations?.address_validation_Receiver}</p>
                                        }
                                    </div>

                                    <div className="col-6 col-md-6">
                                        <label className="required">{t("singleOrder.receiver.t6")}</label>
                                        <input type="text" autoComplete="on" name="firstName"
                                               ref={props.firstNameRefReceiver}
                                               className={selector?.single_info_box?.post_type === '1' ? 'englishFont' : ''}
                                               style={handleBorderColor(selector?.public?.validations?.firstName_validation_Receiver)}
                                               value={selector?.single_receiver?.first_name} id="firstName"
                                               onChange={e => {
                                                   selector?.single_info_box?.post_type === '1' ?
                                                       dispatch(setFirstNameReceiver(handleOnlyEnglish(e.target.value)))
                                                       :
                                                       dispatch(setFirstNameReceiver(e.target.value))
                                               }}/>

                                        {
                                            selector?.public?.validations?.firstName_validation_Receiver &&
                                            <p className="error">{selector?.public?.validations?.firstName_validation_Receiver}</p>
                                        }

                                    </div>
                                    <div className="col-6 col-md-6">
                                        <label className="required">{t("singleOrder.receiver.t7")}</label>
                                        <input type="text" autoComplete="on" name="lastName"
                                               ref={props.lastNameRefReceiver}
                                               className={selector?.single_info_box?.post_type === '1' ? 'englishFont' : ''}
                                               style={handleBorderColor(selector?.public?.validations?.lastName_validation_Receiver)}
                                               value={selector?.single_receiver?.last_name} id="lastName"
                                               onChange={e => {
                                                   selector?.single_info_box?.post_type === '1' ?
                                                       dispatch(setLastNameReceiver(handleOnlyEnglish(e.target.value)))
                                                       :
                                                       dispatch(setLastNameReceiver(e.target.value))
                                               }}/>

                                        {
                                            selector?.public?.validations?.lastName_validation_Receiver &&
                                            <p className="error">{selector?.public?.validations?.lastName_validation_Receiver}</p>
                                        }
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <label className="required">{t("singleOrder.receiver.t8")}</label>
                                        <input type="text" name="mobile"
                                               className={["numeric" + '' +  selector?.single_info_box?.post_type === '1' ? 'englishFont' : '']}
                                               inputMode='numeric'
                                               ref={props.mobileRefReceiver}
                                               style={handleBorderColor(selector?.public?.validations?.mobileNumber_validation_Receiver)}
                                               value={selector?.single_receiver?.mobile_number} id="mobileNumber"
                                               onChange={e => {
                                                   if (selector?.single_info_box?.post_type === '1' && e.target.value.length <= 15) {
                                                       dispatch(setMobileNumberReceiver(removeNonNumeric(handleOnlyEnglish(e.target.value))))
                                                   } else if (e.target.value.length <= 11) {
                                                       dispatch(setMobileNumberReceiver(removeNonNumeric(e.target.value)))
                                                   }
                                               }}
                                        />
                                        {
                                            selector?.public?.validations?.mobileNumber_validation_Receiver &&
                                            <p className="error">{selector?.public?.validations?.mobileNumber_validation_Receiver}</p>
                                        }
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <label
                                            className="">{t("singleOrder.receiver.t27") + ' ' + t("singleOrder.sender.t33")}</label>
                                        <input type="text" name="postalCode"
                                               className={["numeric" + '' + selector?.single_info_box?.post_type === '1' ? 'englishFont' : '']}
                                               inputMode='numeric'
                                               ref={props.postalCodeRefReceiver}
                                               style={handleBorderColor(selector?.public?.validations?.postalCode_validation_Receiver)}
                                               value={selector?.single_receiver?.postal_code} id="postalCode"
                                               onChange={e => e.target.value.length <= 10 && (
                                                   selector?.single_info_box?.post_type === '1' ?
                                                       dispatch(setPostalCodeReceiver(removeNonNumeric(handleOnlyEnglish(e.target.value))))
                                                       :
                                                       dispatch(setPostalCodeReceiver(removeNonNumeric(e.target.value)))
                                               )}
                                        />
                                        {
                                            selector?.public?.validations?.postalCode_validation_Receiver &&
                                            <p className="error">{selector?.public?.validations?.postalCode_validation_Receiver}</p>
                                        }
                                    </div>

                                    <div className="col-md-6"></div>

                                    {selector?.single_info_box?.post_type === '1' &&
                                        <div className="col-12 col-md-6 justify-content-end"
                                             ref={props.imagesRefSingle}>
                                            <div className="selectIMG">

                                                {
                                                    selector?.single_info_box?.shipment_images.length < 3 &&
                                                    <div>
                                                        <button className="selectIMG">
                                                            <label
                                                                htmlFor="upload-photo">{t("homeDesktop.s1.t4.tt32")}</label>
                                                            <input multiple type="file" name="photo" id="upload-photo"
                                                                   onChange={onImageChange} accept="image/*"/>
                                                        </button>
                                                        <p>{t("sendTicket.t32")}</p>
                                                    </div>
                                                }

                                                <div className="listIMG">
                                                    <div className="container">
                                                        <div className="row">
                                                            {
                                                                selector?.single_info_box?.shipment_images.map((item, index) =>
                                                                    <div
                                                                        className="col-6 col-lg-4 mb-2" key={index}>
                                                                        <div className="item">
                                                                            <button onClick={() => removeIMG(index)}
                                                                                    id="removeIMG">
                                                                                <Cancel/>
                                                                            </button>
                                                                            <img src={item} alt="img" loading="lazy"/>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            {
                                                selector?.public?.validations?.images_validation &&
                                                <p className="error">{selector?.public?.validations?.images_validation}</p>
                                            }
                                        </div>
                                    }

                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12 col-md-6 d-flex">
                                                <div className="__btnGroup_yellow">
                                                    <button className="btnEmpty"
                                                            onClick={() => setOtherInput(!otherInput)} id="otherInput">
                                                        {otherInput ? <Remove className="minus"/> :
                                                            <Plus className="plus"/>}
                                                        <span>{otherInput ? t("singleOrder.sender.t31") : t("singleOrder.sender.t30")}</span>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>


                                    {
                                        otherInput && <>
                                            <div className="col-12 col-md-6">
                                                <label className="">{t("singleOrder.receiver.t25")}</label>
                                                <input type="text" name="phone" ref={props.phoneRefReceiver}
                                                       className={["numeric" + '' + selector?.single_info_box?.post_type === '1' ? 'englishFont' : '']}
                                                       style={handleBorderColor(selector?.public?.validations?.phoneNumber_validation_Receiver)}
                                                       inputMode='numeric'
                                                       value={selector?.single_receiver?.phone_number} id="phoneNumber"
                                                       onChange={e => {
                                                           if (selector?.single_info_box?.post_type === '1' && e.target.value.length <= 15) {
                                                               dispatch(setPhoneNumberReceiver(removeNonNumeric(handleOnlyEnglish(e.target.value))))
                                                           } else if (e.target.value.length <= 11) {
                                                               dispatch(setPhoneNumberReceiver(removeNonNumeric(e.target.value)))
                                                           }
                                                       }}
                                                />
                                                {
                                                    selector?.public?.validations?.phoneNumber_validation_Receiver &&
                                                    <p className="error">{selector?.public?.validations?.phoneNumber_validation_Receiver}</p>
                                                }
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <label>{t("singleOrder.receiver.t9")}</label>
                                                <input type="email" name="email" ref={props.emailRefReceiver} id="email"
                                                       className={selector?.single_info_box?.post_type === '1' ? 'englishFont' : ''}
                                                       style={handleBorderColor(selector?.public?.validations?.email_validation_Receiver)}
                                                       value={selector?.single_receiver?.email}
                                                       onChange={e => {
                                                           dispatch(setEmailReceiver(e.target.value))
                                                       }}/>
                                                {
                                                    selector?.public?.validations?.email_validation_Receiver &&
                                                    <p className="error">{selector?.public?.validations?.email_validation_Receiver}</p>
                                                }
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <label>{t("singleOrder.receiver.t10")}</label>
                                                <input type="text" autoComplete="on" name="company" id="company"
                                                       className={selector?.single_info_box?.post_type === '1' ? 'englishFont' : ''}
                                                       ref={props.companyRefReceiver}
                                                       value={selector?.single_receiver?.company}
                                                       style={handleBorderColor(selector?.public?.validations?.company_validation_Receiver)}
                                                       onChange={e => {
                                                           selector?.single_info_box?.post_type === '1' ?
                                                               dispatch(setCompanyReceiver(handleOnlyEnglish(e.target.value)))
                                                               :
                                                               dispatch(setCompanyReceiver(e.target.value))
                                                       }}/>
                                                {
                                                    selector?.public?.validations?.company_validation_Receiver &&
                                                    <p className="error">{selector?.public?.validations?.company_validation_Receiver}</p>
                                                }
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12">
                        <Divider/>
                    </div>

                </div>

            </div>
        </>
    )
}
